import React from 'react';
import CompactSelectPicker from '../ui/CompactSelectPicker';
import { PriorityBarsIcon } from './TaskPriorityBars';
import { PRIORITY_FILTER_LEVELS } from '../../extensions/bundled/task-manager/boardFilters';

const NAMES = { high: 'High', medium: 'Medium', low: 'Low' };

/**
 * The Priority filter chip (card 4.3): a pill that opens the shared
 * CompactSelectPicker menu (owner rule: reuse the existing inputs) with High /
 * Medium / Low, each with the card's own three-bar icon and how many cards
 * carry it. One level at a time, like Trello's quick filter; "Any priority"
 * under the list puts it back.
 *
 * Unset, the trigger reads "Priority" (the picker's placeholder — never the
 * first option pretending to be chosen); set, it shows the level's bars and
 * name and wears the ON look of the other chips.
 */
export default function BoardPriorityFilter({ value = '', counts = {}, onChange }) {
  const on = PRIORITY_FILTER_LEVELS.includes(value);
  const options = PRIORITY_FILTER_LEVELS.map((p) => ({
    value: p,
    label: NAMES[p],
    // The count rides in `leading` so `label` stays the plain name the trigger
    // shows. CSS pins it to the row's right edge in the menu and hides it on
    // the trigger (BoardFilterBar.css).
    leading: (
      <span className="board-filter-priority-option">
        <PriorityBarsIcon priority={p} />
        <span className="board-filter-priority-count">{counts[p] ?? 0}</span>
      </span>
    ),
  }));

  return (
    <CompactSelectPicker
      className={`board-filter-priority${on ? ' board-filter-priority--on' : ''}`}
      menuClassName="board-filter-priority-menu"
      value={on ? value : null}
      options={options}
      placeholder="Priority"
      menuMinWidth={170}
      aria-label={on ? `Priority filter: ${NAMES[value]}` : 'Filter by priority'}
      onChange={(next) => onChange(next)}
      renderFooter={
        on
          ? ({ close }) => (
              <button
                type="button"
                className="board-filter-priority-any"
                onClick={() => {
                  onChange('');
                  close();
                }}
              >
                Any priority
              </button>
            )
          : null
      }
    />
  );
}
